import { Provider } from 'react-redux';
import { Fragment } from 'react';
import { Layouts } from '~/shared';
import { LayoutBuilder } from '~/rage/utils';
import { store } from './redux';
import { MainMenu } from './views/MainMenu';
import { Background } from './components/Background';

const LayoutComponent = () => (
	<Provider store={store}>
		<Fragment>
			<Background />
			<MainMenu />
		</Fragment>
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.MainMenu)
	.build();

export default Layout;
